import type { NamespaceSchema } from './types';

export const reviewSettings: NamespaceSchema = {
  namespace: 'review-settings',
  label: 'Reviews',
  description: 'Customer reviews on car listings — moderation, eligibility, display.',
  sections: [
    {
      label: 'Eligibility',
      fields: [
        { kind: 'boolean', key: 'requires_completed_booking', label: 'Reviewer must have a completed booking', default: true },
        { kind: 'boolean', key: 'allow_anonymous', label: 'Allow anonymous reviews', default: false },
        { kind: 'number', key: 'min_chars', label: 'Minimum review length (chars)', default: 30, min: 0, max: 1000 },
      ],
    },
    {
      label: 'Moderation',
      fields: [
        { kind: 'select', key: 'moderation_mode', label: 'Default moderation', default: 'approve_then_publish', options: [
          { value: 'auto_publish', label: 'Auto-publish' },
          { value: 'approve_then_publish', label: 'Admin approves before publish' },
          { value: 'approve_then_publish_first_only', label: 'Approve first review per user, auto after' },
        ] },
        { kind: 'boolean', key: 'notify_admin_on_new', label: 'Notify admin on new review', default: true },
        { kind: 'boolean', key: 'allow_vendor_reply', label: 'Vendor may reply to reviews', default: true },
      ],
    },
    {
      label: 'Display',
      fields: [
        { kind: 'number', key: 'reviews_per_page', label: 'Reviews per page', default: 10, min: 1, max: 50 },
        { kind: 'boolean', key: 'show_score_breakdown', label: 'Show 5-star breakdown chart', default: true },
      ],
    },
  ],
};
